import {
    SIGNIN,
    AUTHENTICATED,
    SIGNOUT,
    SIGNOUT_SUCCESS,
    SHOW_AUTH_MESSAGE,
    HIDE_AUTH_MESSAGE,
    SIGNUP,
    SIGNUP_SUCCESS,
    SHOW_LOADING,
    SIGNIN_WITH_GOOGLE,
    SIGNIN_WITH_GOOGLE_AUTHENTICATED,
    SIGNIN_WITH_FACEBOOK,
    SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
    SIGNUP_WAIT,
    SET_AUTH_USER,
} from "../constants/Auth";

export const signIn = (user) => {
    return {
        type: SIGNIN,
        payload: user,
    };
};

export const authenticated = (user) => {
    return {
        type: AUTHENTICATED,
        user,
    };
};

export const signOut = () => {
    return {
        type: SIGNOUT,
    };
};

export const signOutSuccess = () => {
    return {
        type: SIGNOUT_SUCCESS,
    };
};

export const signUp = (user) => {
    return {
        type: SIGNUP,
        payload: user,
    };
};

export const signUpSuccess = (user) => {
    return {
        type: SIGNUP_SUCCESS,
        user,
    };
};
export const setAuthUser = (user) => {
    return {
        type: SET_AUTH_USER,
        payload: user,
    };
};
export const signUpWait = (user) => {
    return {
        type: SIGNUP_WAIT,
        user,
    };
};

export const signInWithGoogle = () => {
    return {
        type: SIGNIN_WITH_GOOGLE,
    };
};

export const signInWithGoogleAuthenticated = (token) => {
    return {
        type: SIGNIN_WITH_GOOGLE_AUTHENTICATED,
        token,
    };
};

export const signInWithFacebook = () => {
    return {
        type: SIGNIN_WITH_FACEBOOK,
    };
};

export const signInWithFacebookAuthenticated = (token) => {
    return {
        type: SIGNIN_WITH_FACEBOOK_AUTHENTICATED,
        token,
    };
};

export const showAuthMessage = (message) => {
    return {
        type: SHOW_AUTH_MESSAGE,
        message,
    };
};

export const hideAuthMessage = () => {
    return {
        type: HIDE_AUTH_MESSAGE,
    };
};

export const showLoading = () => {
    return {
        type: SHOW_LOADING,
    };
};
